import { modals } from  '../../blocks-ui/modals/modals';

(function() {

  const formsArr = document.querySelectorAll('.js-presubscribe-form');

  formsArr.forEach((preform) => {
    const btn = preform.querySelector('.js-presubscribe-group button');
    const emailInput = preform.querySelector('.js-presubscribe-group input');
    btn.addEventListener('click', () => {
      modals.open('subscribe-modal', (modal) => {
        const modalEmailInput = modal.querySelector('#subscribe-email');
        if (emailInput.value) {
          modalEmailInput.value = emailInput.value;
          emailInput.value = '';
        }
      });
    });
  })
})();